import React from "react";
import { useBlogPage } from "./hook";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { CreateBlogModal } from "../../organisms/modal/CreateBlogModal";
import { DetailBlogModal } from "../../organisms/modal/DetailBlogModal";
import { Blog } from "../../../ducks/blog/types";
import { EditBlogModal } from "../../organisms/modal/EditBlogModal";
import { Resource, Permission } from "../../../constants/permissions";
import { useBlogToast } from "./hook";

export const BlogPage = () => {
  const { showToast } = useBlogToast();
  const {
    tableHeaders,
    blogs,
    fetchDataFunction,
    isCreateModalOpen,
    isEditModalOpen,
    isDetailModalOpen,
    handleOpenCreateModal,
    handleCloseCreateModal,
    handleCloseDetailModal,
    page,
    pageSize,
    totalItems,
    hasPagination,
    handleRowDelete,
    handleCloseEditModal,
    handleOpenEditModal,
    selectedBlog,
    setSelectedBlog,
    handlePageChange,
    refetchBlogs,
  } = useBlogPage();

  return (
    <>
      <MainTemplate
        title="Blog"
        useFitHeight
        button={{
          text: "Create",
          variant: "filled",
          onClick: handleOpenCreateModal,
          permission: {
            resource: Resource.BLOGS,
            permission: Permission.CREATE,
          },
        }}
      >
        <TableTemplate<Blog & { no: number }>
          headers={tableHeaders}
          data={blogs}
          fetchDataFunction={fetchDataFunction}
          columnWidths={["6%", "45%", "20%", "15%", "14%"]} // No: 6%, Title: 45%, ...
          hasPagination={hasPagination}
          perPage={pageSize}
          total={totalItems}
          currentPage={page}
          defaultSort={{ field: 'title', order: 'asc' }}
          editable
          deletable
          showHeaderDeleteIcon={false}
          resource={Resource.BLOGS}
          onPermissionError={showToast}
          onDelete={handleRowDelete}
          onEdit={(blog) => {
            setSelectedBlog(blog);
            handleOpenEditModal()
          }}
          stickyHeader
          onSetPage={handlePageChange}
        />
      </MainTemplate>

      <CreateBlogModal
        isOpen={isCreateModalOpen}
        onClose={handleCloseCreateModal}
        refetchBlogs={refetchBlogs}
      />

      {selectedBlog && (
        <EditBlogModal
          isOpen={isEditModalOpen}
          onClose={handleCloseEditModal}
          defaultValues={{
            title: selectedBlog.title,
            author_name: selectedBlog.author_name,
            content: selectedBlog.content,
            image: null,
            publish: selectedBlog.publish,
            existingImageUrl: selectedBlog.image,
          }}
          blogId={selectedBlog.id}
          refetchBlogs={refetchBlogs}
        />
      )}

      {selectedBlog && isDetailModalOpen && (
        <DetailBlogModal
          isOpen={isDetailModalOpen}
          onClose={handleCloseDetailModal}
          blog={selectedBlog}
        />
      )}

    </>
  );
};
